import _definePage_default_0 from '/builds/nangman/nangman-web/src/pages/about-nangman/index.vue?definePage&vue'
import { _mergeRouteRecord } from 'unplugin-vue-router/runtime'
import _definePage_default_2 from '/builds/nangman/nangman-web/src/pages/analysis/index.vue?definePage&vue'
import _definePage_default_3 from '/builds/nangman/nangman-web/src/pages/appstore/index.vue?definePage&vue'
import _definePage_default_4 from '/builds/nangman/nangman-web/src/pages/auth/callback.vue?definePage&vue'
import _definePage_default_5 from '/builds/nangman/nangman-web/src/pages/auth/find-id.vue?definePage&vue'
import _definePage_default_6 from '/builds/nangman/nangman-web/src/pages/auth/finish.vue?definePage&vue'
import _definePage_default_7 from '/builds/nangman/nangman-web/src/pages/auth/join.vue?definePage&vue'
import _definePage_default_8 from '/builds/nangman/nangman-web/src/pages/auth/login.vue?definePage&vue'
import _definePage_default_9 from '/builds/nangman/nangman-web/src/pages/auth/reset.vue?definePage&vue'
import _definePage_default_10 from '/builds/nangman/nangman-web/src/pages/coupon/index.vue?definePage&vue'
import _definePage_default_11 from '/builds/nangman/nangman-web/src/pages/dev/test.vue?definePage&vue'
import _definePage_default_12 from '/builds/nangman/nangman-web/src/pages/documents/privacy.vue?definePage&vue'
import _definePage_default_13 from '/builds/nangman/nangman-web/src/pages/documents/terms.vue?definePage&vue'
import _definePage_default_14 from '/builds/nangman/nangman-web/src/pages/error/error01.vue?definePage&vue'
import _definePage_default_15 from '/builds/nangman/nangman-web/src/pages/fortune/index.vue?definePage&vue'
import _definePage_default_16 from '/builds/nangman/nangman-web/src/pages/gift/[code].vue?definePage&vue'
import _definePage_default_17 from '/builds/nangman/nangman-web/src/pages/Inspire.vue?definePage&vue'
import _definePage_default_18 from '/builds/nangman/nangman-web/src/pages/m/saju-insight/[id].vue?definePage&vue'
import _definePage_default_19 from '/builds/nangman/nangman-web/src/pages/m/saju-insight/basic.vue?definePage&vue'
import _definePage_default_20 from '/builds/nangman/nangman-web/src/pages/m/saju-insight/monthly-fortune.vue?definePage&vue'
import _definePage_default_21 from '/builds/nangman/nangman-web/src/pages/m/saju-insight/nangman-harmony.vue?definePage&vue'
import _definePage_default_22 from '/builds/nangman/nangman-web/src/pages/m/saju-insight/nangman-naming.vue?definePage&vue'
import _definePage_default_23 from '/builds/nangman/nangman-web/src/pages/m/saju-insight/personality.vue?definePage&vue'
import _definePage_default_24 from '/builds/nangman/nangman-web/src/pages/m/saju-insight/primary.vue?definePage&vue'
import _definePage_default_25 from '/builds/nangman/nangman-web/src/pages/m/saju-insight/yearly-fortune.vue?definePage&vue'
import _definePage_default_26 from '/builds/nangman/nangman-web/src/pages/m/saju-insight/yongsin.vue?definePage&vue'
import _definePage_default_27 from '/builds/nangman/nangman-web/src/pages/m/saju-insight/yongsin-light.vue?definePage&vue'
import _definePage_default_28 from '/builds/nangman/nangman-web/src/pages/main/index.vue?definePage&vue'
import _definePage_default_29 from '/builds/nangman/nangman-web/src/pages/mobile/analysis-saju-monthly-fortune/index.vue?definePage&vue'
import _definePage_default_30 from '/builds/nangman/nangman-web/src/pages/mobile/analysis-saju-personality/index.vue?definePage&vue'
import _definePage_default_31 from '/builds/nangman/nangman-web/src/pages/mobile/analysis-saju-reading/index.vue?definePage&vue'
import _definePage_default_32 from '/builds/nangman/nangman-web/src/pages/mobile/analysis-saju-yearly-fortune/index.vue?definePage&vue'
import _definePage_default_33 from '/builds/nangman/nangman-web/src/pages/mobile/analysis-saju-youngsin/index.vue?definePage&vue'
import _definePage_default_34 from '/builds/nangman/nangman-web/src/pages/mobile/five-element-diagram/index.vue?definePage&vue'
import _definePage_default_35 from '/builds/nangman/nangman-web/src/pages/mobile/saju-analysis/index.vue?definePage&vue'
import _definePage_default_36 from '/builds/nangman/nangman-web/src/pages/mobile/saju-disposition/index.vue?definePage&vue'
import _definePage_default_37 from '/builds/nangman/nangman-web/src/pages/mobile/saju-iljin/index.vue?definePage&vue'
import _definePage_default_38 from '/builds/nangman/nangman-web/src/pages/mobile/saju-reading/index.vue?definePage&vue'
import _definePage_default_39 from '/builds/nangman/nangman-web/src/pages/mypage/history.vue?definePage&vue'
import _definePage_default_40 from '/builds/nangman/nangman-web/src/pages/mypage/inquiry.vue?definePage&vue'
import _definePage_default_41 from '/builds/nangman/nangman-web/src/pages/mypage/inquiryFinish.vue?definePage&vue'
import _definePage_default_42 from '/builds/nangman/nangman-web/src/pages/mypage/inquiryGuest.vue?definePage&vue'
import _definePage_default_43 from '/builds/nangman/nangman-web/src/pages/mypage/inquiryList.vue?definePage&vue'
import _definePage_default_44 from '/builds/nangman/nangman-web/src/pages/mypage/inquiryView.vue?definePage&vue'
import _definePage_default_45 from '/builds/nangman/nangman-web/src/pages/mypage/moreinfo.vue?definePage&vue'
import _definePage_default_46 from '/builds/nangman/nangman-web/src/pages/mypage/myinfo.vue?definePage&vue'
import _definePage_default_47 from '/builds/nangman/nangman-web/src/pages/mypage/snsPw.vue?definePage&vue'
import _definePage_default_48 from '/builds/nangman/nangman-web/src/pages/mypage/subscription.vue?definePage&vue'
import _definePage_default_49 from '/builds/nangman/nangman-web/src/pages/mypage/subscrPaymentView.vue?definePage&vue'
import _definePage_default_50 from '/builds/nangman/nangman-web/src/pages/mypage/withdraw-finish.vue?definePage&vue'
import _definePage_default_51 from '/builds/nangman/nangman-web/src/pages/nangman-center/index.vue?definePage&vue'
import _definePage_default_52 from '/builds/nangman/nangman-web/src/pages/nangman-center/essay/[essayId].vue?definePage&vue'
import _definePage_default_53 from '/builds/nangman/nangman-web/src/pages/onboarding/index.vue?definePage&vue'
import _definePage_default_54 from '/builds/nangman/nangman-web/src/pages/partner/smartwel.vue?definePage&vue'
import _definePage_default_55 from '/builds/nangman/nangman-web/src/pages/purchase/exchange.vue?definePage&vue'
import _definePage_default_56 from '/builds/nangman/nangman-web/src/pages/purchase/gift-box.vue?definePage&vue'
import _definePage_default_57 from '/builds/nangman/nangman-web/src/pages/purchase/gift-claim.vue?definePage&vue'
import _definePage_default_58 from '/builds/nangman/nangman-web/src/pages/purchase/gift-view.vue?definePage&vue'
import _definePage_default_59 from '/builds/nangman/nangman-web/src/pages/purchase/nmspFinishPoint.vue?definePage&vue'
import _definePage_default_60 from '/builds/nangman/nangman-web/src/pages/purchase/nmspFinishPointEnd.vue?definePage&vue'
import _definePage_default_61 from '/builds/nangman/nangman-web/src/pages/purchase/nmspFinishPointFail.vue?definePage&vue'
import _definePage_default_62 from '/builds/nangman/nangman-web/src/pages/purchase/points.vue?definePage&vue'
import _definePage_default_63 from '/builds/nangman/nangman-web/src/pages/purchase/ticket-detail.vue?definePage&vue'
import _definePage_default_64 from '/builds/nangman/nangman-web/src/pages/purchase/tickets.vue?definePage&vue'
import _definePage_default_65 from '/builds/nangman/nangman-web/src/pages/saju-input/index.vue?definePage&vue'
import _definePage_default_66 from '/builds/nangman/nangman-web/src/pages/saju-insight/index.vue?definePage&vue'
import _definePage_default_67 from '/builds/nangman/nangman-web/src/pages/saju-naming/index.vue?definePage&vue'
import _definePage_default_68 from '/builds/nangman/nangman-web/src/pages/saju-print/print-nor.vue?definePage&vue'
import _definePage_default_69 from '/builds/nangman/nangman-web/src/pages/saju-print/print-pro.vue?definePage&vue'
import _definePage_default_70 from '/builds/nangman/nangman-web/src/pages/saju-result/index.vue?definePage&vue'
import _definePage_default_71 from '/builds/nangman/nangman-web/src/pages/saju-service/index.vue?definePage&vue'
import _definePage_default_72 from '/builds/nangman/nangman-web/src/pages/selection/index.vue?definePage&vue'

export const routes = [
  {
    path: '/about-nangman',
    /* internal name: 'about-nangman' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: 'about-nangman',
        component: () => import('/builds/nangman/nangman-web/src/pages/about-nangman/index.vue'),
        /* no children */
      },
  _definePage_default_0
  )
    ],
  },
  {
    path: '/analysis',
    /* internal name: 'analysis' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: 'analysis',
        component: () => import('/builds/nangman/nangman-web/src/pages/analysis/index.vue'),
        /* no children */
      },
  _definePage_default_2
  )
    ],
  },
  {
    path: '/appstore',
    /* internal name: 'appstore' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: 'appstore',
        component: () => import('/builds/nangman/nangman-web/src/pages/appstore/index.vue'),
        /* no children */
      },
  _definePage_default_3
  )
    ],
  },
  {
    path: '/auth',
    /* internal name: 'auth' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: 'callback',
        name: 'auth-callback',
        component: () => import('/builds/nangman/nangman-web/src/pages/auth/callback.vue'),
        /* no children */
      },
  _definePage_default_4
  ),
  _mergeRouteRecord(
      {
        path: 'find-id',
        name: 'auth-find-id',
        component: () => import('/builds/nangman/nangman-web/src/pages/auth/find-id.vue'),
        /* no children */
      },
  _definePage_default_5
  ),
  _mergeRouteRecord(
      {
        path: 'finish',
        name: 'auth-finish',
        component: () => import('/builds/nangman/nangman-web/src/pages/auth/finish.vue'),
        /* no children */
      },
  _definePage_default_6
  ),
  _mergeRouteRecord(
      {
        path: 'join',
        name: 'auth-join',
        component: () => import('/builds/nangman/nangman-web/src/pages/auth/join.vue'),
        /* no children */
      },
  _definePage_default_7
  ),
  _mergeRouteRecord(
      {
        path: 'login',
        name: 'auth-login',
        component: () => import('/builds/nangman/nangman-web/src/pages/auth/login.vue'),
        /* no children */
      },
  _definePage_default_8
  ),
  _mergeRouteRecord(
      {
        path: 'reset',
        name: 'auth-reset',
        component: () => import('/builds/nangman/nangman-web/src/pages/auth/reset.vue'),
        /* no children */
      },
  _definePage_default_9
  )
    ],
  },
  {
    path: '/coupon',
    /* internal name: 'coupon' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: 'coupon',
        component: () => import('/builds/nangman/nangman-web/src/pages/coupon/index.vue'),
        /* no children */
      },
  _definePage_default_10
  )
    ],
  },
  {
    path: '/dev',
    /* internal name: 'dev' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: 'test',
        name: 'dev-test',
        component: () => import('/builds/nangman/nangman-web/src/pages/dev/test.vue'),
        /* no children */
      },
  _definePage_default_11
  )
    ],
  },
  {
    path: '/documents',
    /* internal name: 'documents' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: 'privacy',
        name: 'documents-privacy',
        component: () => import('/builds/nangman/nangman-web/src/pages/documents/privacy.vue'),
        /* no children */
      },
  _definePage_default_12
  ),
  _mergeRouteRecord(
      {
        path: 'terms',
        name: 'documents-terms',
        component: () => import('/builds/nangman/nangman-web/src/pages/documents/terms.vue'),
        /* no children */
      },
  _definePage_default_13
  )
    ],
  },
  {
    path: '/error',
    /* internal name: 'error' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: 'error01',
        name: 'error-error01',
        component: () => import('/builds/nangman/nangman-web/src/pages/error/error01.vue'),
        /* no children */
      },
  _definePage_default_14
  )
    ],
  },
  {
    path: '/fortune',
    /* internal name: 'fortune' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: 'fortune',
        component: () => import('/builds/nangman/nangman-web/src/pages/fortune/index.vue'),
        /* no children */
      },
  _definePage_default_15
  )
    ],
  },
  {
    path: '/gift',
    /* internal name: 'gift' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: ':code',
        name: 'gift-code',
        component: () => import('/builds/nangman/nangman-web/src/pages/gift/[code].vue'),
        /* no children */
      },
  _definePage_default_16
  )
    ],
  },
  _mergeRouteRecord(
  {
    path: '/Inspire',
    name: 'inspire',
    component: () => import('/builds/nangman/nangman-web/src/pages/Inspire.vue'),
    /* no children */
  },
  _definePage_default_17
  ),
  {
    path: '/m',
    /* internal name: 'm' */
    /* no component */
    children: [
      {
        path: 'saju-insight',
        /* internal name: 'msaju-insight' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: ':id',
            name: 'msaju-insight-id',
            component: () => import('/builds/nangman/nangman-web/src/pages/m/saju-insight/[id].vue'),
            /* no children */
          },
  _definePage_default_18
  ),
  _mergeRouteRecord(
          {
            path: 'basic',
            name: 'msaju-insight-basic',
            component: () => import('/builds/nangman/nangman-web/src/pages/m/saju-insight/basic.vue'),
            /* no children */
          },
  _definePage_default_19
  ),
          {
            path: 'components',
            /* internal name: 'msaju-insight-components' */
            /* no component */
            children: [
              {
                path: 'SajuInsightHome',
                name: 'msaju-insight-components-saju-insight-home',
                component: () => import('/builds/nangman/nangman-web/src/pages/m/saju-insight/components/SajuInsightHome.vue'),
                /* no children */
              },
              {
                path: 'YongsinLightCover',
                name: 'msaju-insight-components-yongsin-light-cover',
                component: () => import('/builds/nangman/nangman-web/src/pages/m/saju-insight/components/YongsinLightCover.vue'),
                /* no children */
              },
              {
                path: 'YongsinLightTOC',
                name: 'msaju-insight-components-yongsin-light-toc',
                component: () => import('/builds/nangman/nangman-web/src/pages/m/saju-insight/components/YongsinLightTOC.vue'),
                /* no children */
              }
            ],
          },
  _mergeRouteRecord(
          {
            path: 'monthly-fortune',
            name: 'msaju-insight-monthly-fortune',
            component: () => import('/builds/nangman/nangman-web/src/pages/m/saju-insight/monthly-fortune.vue'),
            /* no children */
          },
  _definePage_default_20
  ),
  _mergeRouteRecord(
          {
            path: 'nangman-harmony',
            name: 'msaju-insight-nangman-harmony',
            component: () => import('/builds/nangman/nangman-web/src/pages/m/saju-insight/nangman-harmony.vue'),
            /* no children */
          },
  _definePage_default_21
  ),
  _mergeRouteRecord(
          {
            path: 'nangman-naming',
            name: 'msaju-insight-nangman-naming',
            component: () => import('/builds/nangman/nangman-web/src/pages/m/saju-insight/nangman-naming.vue'),
            /* no children */
          },
  _definePage_default_22
  ),
  _mergeRouteRecord(
          {
            path: 'personality',
            name: 'msaju-insight-personality',
            component: () => import('/builds/nangman/nangman-web/src/pages/m/saju-insight/personality.vue'),
            /* no children */
          },
  _definePage_default_23
  ),
  _mergeRouteRecord(
          {
            path: 'primary',
            name: 'msaju-insight-primary',
            component: () => import('/builds/nangman/nangman-web/src/pages/m/saju-insight/primary.vue'),
            /* no children */
          },
  _definePage_default_24
  ),
  _mergeRouteRecord(
          {
            path: 'yearly-fortune',
            name: 'msaju-insight-yearly-fortune',
            component: () => import('/builds/nangman/nangman-web/src/pages/m/saju-insight/yearly-fortune.vue'),
            /* no children */
          },
  _definePage_default_25
  ),
  _mergeRouteRecord(
          {
            path: 'yongsin',
            name: 'msaju-insight-yongsin',
            component: () => import('/builds/nangman/nangman-web/src/pages/m/saju-insight/yongsin.vue'),
            /* no children */
          },
  _definePage_default_26
  ),
  _mergeRouteRecord(
          {
            path: 'yongsin-light',
            name: 'msaju-insight-yongsin-light',
            component: () => import('/builds/nangman/nangman-web/src/pages/m/saju-insight/yongsin-light.vue'),
            /* no children */
          },
  _definePage_default_27
  )
        ],
      }
    ],
  },
  {
    path: '/main',
    /* internal name: 'main' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: 'main',
        component: () => import('/builds/nangman/nangman-web/src/pages/main/index.vue'),
        /* no children */
      },
  _definePage_default_28
  )
    ],
  },
  {
    path: '/mobile',
    /* internal name: 'mobile' */
    /* no component */
    children: [
      {
        path: 'analysis-saju-monthly-fortune',
        /* internal name: 'mobile-analysis-saju-monthly-fortune' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'mobile-analysis-saju-monthly-fortune',
            component: () => import('/builds/nangman/nangman-web/src/pages/mobile/analysis-saju-monthly-fortune/index.vue'),
            /* no children */
          },
  _definePage_default_29
  ),
          {
            path: '_com_payment_info',
            name: 'mobile-analysis-saju-monthly-fortune-com-payment-info',
            component: () => import('/builds/nangman/nangman-web/src/pages/mobile/analysis-saju-monthly-fortune/_com_payment_info.vue'),
            /* no children */
          },
          {
            path: '_summary_01',
            name: 'mobile-analysis-saju-monthly-fortune-summary01',
            component: () => import('/builds/nangman/nangman-web/src/pages/mobile/analysis-saju-monthly-fortune/_summary_01.vue'),
            /* no children */
          },
          {
            path: '_summary_02',
            name: 'mobile-analysis-saju-monthly-fortune-summary02',
            component: () => import('/builds/nangman/nangman-web/src/pages/mobile/analysis-saju-monthly-fortune/_summary_02.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'analysis-saju-personality',
        /* internal name: 'mobile-analysis-saju-personality' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'mobile-analysis-saju-personality',
            component: () => import('/builds/nangman/nangman-web/src/pages/mobile/analysis-saju-personality/index.vue'),
            /* no children */
          },
  _definePage_default_30
  ),
          {
            path: '_com_payment_info',
            name: 'mobile-analysis-saju-personality-com-payment-info',
            component: () => import('/builds/nangman/nangman-web/src/pages/mobile/analysis-saju-personality/_com_payment_info.vue'),
            /* no children */
          },
          {
            path: '_pop_desc',
            name: 'mobile-analysis-saju-personality-pop-desc',
            component: () => import('/builds/nangman/nangman-web/src/pages/mobile/analysis-saju-personality/_pop_desc.vue'),
            /* no children */
          },
          {
            path: '_summary_01',
            name: 'mobile-analysis-saju-personality-summary01',
            component: () => import('/builds/nangman/nangman-web/src/pages/mobile/analysis-saju-personality/_summary_01.vue'),
            /* no children */
          },
          {
            path: '_summary_02',
            name: 'mobile-analysis-saju-personality-summary02',
            component: () => import('/builds/nangman/nangman-web/src/pages/mobile/analysis-saju-personality/_summary_02.vue'),
            /* no children */
          },
          {
            path: '_summary_sub_01',
            name: 'mobile-analysis-saju-personality-summary-sub01',
            component: () => import('/builds/nangman/nangman-web/src/pages/mobile/analysis-saju-personality/_summary_sub_01.vue'),
            /* no children */
          },
          {
            path: '_summary_sub_02',
            name: 'mobile-analysis-saju-personality-summary-sub02',
            component: () => import('/builds/nangman/nangman-web/src/pages/mobile/analysis-saju-personality/_summary_sub_02.vue'),
            /* no children */
          },
          {
            path: '_summary_sub_03',
            name: 'mobile-analysis-saju-personality-summary-sub03',
            component: () => import('/builds/nangman/nangman-web/src/pages/mobile/analysis-saju-personality/_summary_sub_03.vue'),
            /* no children */
          },
          {
            path: '_summary_sub_04',
            name: 'mobile-analysis-saju-personality-summary-sub04',
            component: () => import('/builds/nangman/nangman-web/src/pages/mobile/analysis-saju-personality/_summary_sub_04.vue'),
            /* no children */
          },
          {
            path: '_summary_sub_05',
            name: 'mobile-analysis-saju-personality-summary-sub05',
            component: () => import('/builds/nangman/nangman-web/src/pages/mobile/analysis-saju-personality/_summary_sub_05.vue'),
            /* no children */
          },
          {
            path: '_summary_sub_06',
            name: 'mobile-analysis-saju-personality-summary-sub06',
            component: () => import('/builds/nangman/nangman-web/src/pages/mobile/analysis-saju-personality/_summary_sub_06.vue'),
            /* no children */
          },
          {
            path: '_summary_sub_07',
            name: 'mobile-analysis-saju-personality-summary-sub07',
            component: () => import('/builds/nangman/nangman-web/src/pages/mobile/analysis-saju-personality/_summary_sub_07.vue'),
            /* no children */
          },
          {
            path: '_summary_sub_08',
            name: 'mobile-analysis-saju-personality-summary-sub08',
            component: () => import('/builds/nangman/nangman-web/src/pages/mobile/analysis-saju-personality/_summary_sub_08.vue'),
            /* no children */
          },
          {
            path: '_summary_sub_09',
            name: 'mobile-analysis-saju-personality-summary-sub09',
            component: () => import('/builds/nangman/nangman-web/src/pages/mobile/analysis-saju-personality/_summary_sub_09.vue'),
            /* no children */
          },
          {
            path: '_summary_sub_10',
            name: 'mobile-analysis-saju-personality-summary-sub10',
            component: () => import('/builds/nangman/nangman-web/src/pages/mobile/analysis-saju-personality/_summary_sub_10.vue'),
            /* no children */
          },
          {
            path: '_summary_sub_11',
            name: 'mobile-analysis-saju-personality-summary-sub11',
            component: () => import('/builds/nangman/nangman-web/src/pages/mobile/analysis-saju-personality/_summary_sub_11.vue'),
            /* no children */
          },
          {
            path: '_summary_sub_12',
            name: 'mobile-analysis-saju-personality-summary-sub12',
            component: () => import('/builds/nangman/nangman-web/src/pages/mobile/analysis-saju-personality/_summary_sub_12.vue'),
            /* no children */
          },
          {
            path: '_summary_sub_13',
            name: 'mobile-analysis-saju-personality-summary-sub13',
            component: () => import('/builds/nangman/nangman-web/src/pages/mobile/analysis-saju-personality/_summary_sub_13.vue'),
            /* no children */
          },
          {
            path: '_summary_sub_14',
            name: 'mobile-analysis-saju-personality-summary-sub14',
            component: () => import('/builds/nangman/nangman-web/src/pages/mobile/analysis-saju-personality/_summary_sub_14.vue'),
            /* no children */
          },
          {
            path: '_summary_sub_15',
            name: 'mobile-analysis-saju-personality-summary-sub15',
            component: () => import('/builds/nangman/nangman-web/src/pages/mobile/analysis-saju-personality/_summary_sub_15.vue'),
            /* no children */
          },
          {
            path: '_summary_sub_16',
            name: 'mobile-analysis-saju-personality-summary-sub16',
            component: () => import('/builds/nangman/nangman-web/src/pages/mobile/analysis-saju-personality/_summary_sub_16.vue'),
            /* no children */
          },
          {
            path: '_summary_sub_17',
            name: 'mobile-analysis-saju-personality-summary-sub17',
            component: () => import('/builds/nangman/nangman-web/src/pages/mobile/analysis-saju-personality/_summary_sub_17.vue'),
            /* no children */
          },
          {
            path: '_summary_sub_18',
            name: 'mobile-analysis-saju-personality-summary-sub18',
            component: () => import('/builds/nangman/nangman-web/src/pages/mobile/analysis-saju-personality/_summary_sub_18.vue'),
            /* no children */
          },
          {
            path: '_summary_sub_19',
            name: 'mobile-analysis-saju-personality-summary-sub19',
            component: () => import('/builds/nangman/nangman-web/src/pages/mobile/analysis-saju-personality/_summary_sub_19.vue'),
            /* no children */
          },
          {
            path: '_summary_sub_20',
            name: 'mobile-analysis-saju-personality-summary-sub20',
            component: () => import('/builds/nangman/nangman-web/src/pages/mobile/analysis-saju-personality/_summary_sub_20.vue'),
            /* no children */
          },
          {
            path: '_summary_sub_21',
            name: 'mobile-analysis-saju-personality-summary-sub21',
            component: () => import('/builds/nangman/nangman-web/src/pages/mobile/analysis-saju-personality/_summary_sub_21.vue'),
            /* no children */
          },
          {
            path: '_summary_sub_22',
            name: 'mobile-analysis-saju-personality-summary-sub22',
            component: () => import('/builds/nangman/nangman-web/src/pages/mobile/analysis-saju-personality/_summary_sub_22.vue'),
            /* no children */
          },
          {
            path: '_summary_sub_23',
            name: 'mobile-analysis-saju-personality-summary-sub23',
            component: () => import('/builds/nangman/nangman-web/src/pages/mobile/analysis-saju-personality/_summary_sub_23.vue'),
            /* no children */
          },
          {
            path: '_summary_sub_24',
            name: 'mobile-analysis-saju-personality-summary-sub24',
            component: () => import('/builds/nangman/nangman-web/src/pages/mobile/analysis-saju-personality/_summary_sub_24.vue'),
            /* no children */
          },
          {
            path: '_summary_sub_25',
            name: 'mobile-analysis-saju-personality-summary-sub25',
            component: () => import('/builds/nangman/nangman-web/src/pages/mobile/analysis-saju-personality/_summary_sub_25.vue'),
            /* no children */
          },
          {
            path: '_summary_sub_26',
            name: 'mobile-analysis-saju-personality-summary-sub26',
            component: () => import('/builds/nangman/nangman-web/src/pages/mobile/analysis-saju-personality/_summary_sub_26.vue'),
            /* no children */
          },
          {
            path: '_summary_sub_27',
            name: 'mobile-analysis-saju-personality-summary-sub27',
            component: () => import('/builds/nangman/nangman-web/src/pages/mobile/analysis-saju-personality/_summary_sub_27.vue'),
            /* no children */
          },
          {
            path: '_summary_sub_28',
            name: 'mobile-analysis-saju-personality-summary-sub28',
            component: () => import('/builds/nangman/nangman-web/src/pages/mobile/analysis-saju-personality/_summary_sub_28.vue'),
            /* no children */
          },
          {
            path: '_summary_sub_29',
            name: 'mobile-analysis-saju-personality-summary-sub29',
            component: () => import('/builds/nangman/nangman-web/src/pages/mobile/analysis-saju-personality/_summary_sub_29.vue'),
            /* no children */
          },
          {
            path: '_summary_sub_30',
            name: 'mobile-analysis-saju-personality-summary-sub30',
            component: () => import('/builds/nangman/nangman-web/src/pages/mobile/analysis-saju-personality/_summary_sub_30.vue'),
            /* no children */
          },
          {
            path: '_summary_sub_31',
            name: 'mobile-analysis-saju-personality-summary-sub31',
            component: () => import('/builds/nangman/nangman-web/src/pages/mobile/analysis-saju-personality/_summary_sub_31.vue'),
            /* no children */
          },
          {
            path: '_summary_sub_32',
            name: 'mobile-analysis-saju-personality-summary-sub32',
            component: () => import('/builds/nangman/nangman-web/src/pages/mobile/analysis-saju-personality/_summary_sub_32.vue'),
            /* no children */
          },
          {
            path: '_summary_sub_33',
            name: 'mobile-analysis-saju-personality-summary-sub33',
            component: () => import('/builds/nangman/nangman-web/src/pages/mobile/analysis-saju-personality/_summary_sub_33.vue'),
            /* no children */
          },
          {
            path: '_summary_sub_34',
            name: 'mobile-analysis-saju-personality-summary-sub34',
            component: () => import('/builds/nangman/nangman-web/src/pages/mobile/analysis-saju-personality/_summary_sub_34.vue'),
            /* no children */
          },
          {
            path: '_summary_sub_35',
            name: 'mobile-analysis-saju-personality-summary-sub35',
            component: () => import('/builds/nangman/nangman-web/src/pages/mobile/analysis-saju-personality/_summary_sub_35.vue'),
            /* no children */
          },
          {
            path: '_summary_sub_36',
            name: 'mobile-analysis-saju-personality-summary-sub36',
            component: () => import('/builds/nangman/nangman-web/src/pages/mobile/analysis-saju-personality/_summary_sub_36.vue'),
            /* no children */
          },
          {
            path: '_summary_sub_37',
            name: 'mobile-analysis-saju-personality-summary-sub37',
            component: () => import('/builds/nangman/nangman-web/src/pages/mobile/analysis-saju-personality/_summary_sub_37.vue'),
            /* no children */
          },
          {
            path: '_summary_sub_38',
            name: 'mobile-analysis-saju-personality-summary-sub38',
            component: () => import('/builds/nangman/nangman-web/src/pages/mobile/analysis-saju-personality/_summary_sub_38.vue'),
            /* no children */
          },
          {
            path: '_summary_sub_39',
            name: 'mobile-analysis-saju-personality-summary-sub39',
            component: () => import('/builds/nangman/nangman-web/src/pages/mobile/analysis-saju-personality/_summary_sub_39.vue'),
            /* no children */
          },
          {
            path: '_summary_sub_40',
            name: 'mobile-analysis-saju-personality-summary-sub40',
            component: () => import('/builds/nangman/nangman-web/src/pages/mobile/analysis-saju-personality/_summary_sub_40.vue'),
            /* no children */
          },
          {
            path: '_summary_sub_41',
            name: 'mobile-analysis-saju-personality-summary-sub41',
            component: () => import('/builds/nangman/nangman-web/src/pages/mobile/analysis-saju-personality/_summary_sub_41.vue'),
            /* no children */
          },
          {
            path: '_summary_sub_42',
            name: 'mobile-analysis-saju-personality-summary-sub42',
            component: () => import('/builds/nangman/nangman-web/src/pages/mobile/analysis-saju-personality/_summary_sub_42.vue'),
            /* no children */
          },
          {
            path: '_summary_sub_43',
            name: 'mobile-analysis-saju-personality-summary-sub43',
            component: () => import('/builds/nangman/nangman-web/src/pages/mobile/analysis-saju-personality/_summary_sub_43.vue'),
            /* no children */
          },
          {
            path: '_summary_sub_44',
            name: 'mobile-analysis-saju-personality-summary-sub44',
            component: () => import('/builds/nangman/nangman-web/src/pages/mobile/analysis-saju-personality/_summary_sub_44.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'analysis-saju-reading',
        /* internal name: 'mobile-analysis-saju-reading' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'mobile-analysis-saju-reading',
            component: () => import('/builds/nangman/nangman-web/src/pages/mobile/analysis-saju-reading/index.vue'),
            /* no children */
          },
  _definePage_default_31
  ),
          {
            path: '_pop_desc',
            name: 'mobile-analysis-saju-reading-pop-desc',
            component: () => import('/builds/nangman/nangman-web/src/pages/mobile/analysis-saju-reading/_pop_desc.vue'),
            /* no children */
          },
          {
            path: '_summary_01',
            name: 'mobile-analysis-saju-reading-summary01',
            component: () => import('/builds/nangman/nangman-web/src/pages/mobile/analysis-saju-reading/_summary_01.vue'),
            /* no children */
          },
          {
            path: '_summary_02',
            name: 'mobile-analysis-saju-reading-summary02',
            component: () => import('/builds/nangman/nangman-web/src/pages/mobile/analysis-saju-reading/_summary_02.vue'),
            /* no children */
          },
          {
            path: '_summary_sub_01',
            name: 'mobile-analysis-saju-reading-summary-sub01',
            component: () => import('/builds/nangman/nangman-web/src/pages/mobile/analysis-saju-reading/_summary_sub_01.vue'),
            /* no children */
          },
          {
            path: '_summary_sub_02',
            name: 'mobile-analysis-saju-reading-summary-sub02',
            component: () => import('/builds/nangman/nangman-web/src/pages/mobile/analysis-saju-reading/_summary_sub_02.vue'),
            /* no children */
          },
          {
            path: '_summary_sub_03',
            name: 'mobile-analysis-saju-reading-summary-sub03',
            component: () => import('/builds/nangman/nangman-web/src/pages/mobile/analysis-saju-reading/_summary_sub_03.vue'),
            /* no children */
          },
          {
            path: '_summary_sub_04',
            name: 'mobile-analysis-saju-reading-summary-sub04',
            component: () => import('/builds/nangman/nangman-web/src/pages/mobile/analysis-saju-reading/_summary_sub_04.vue'),
            /* no children */
          },
          {
            path: '_summary_sub_05',
            name: 'mobile-analysis-saju-reading-summary-sub05',
            component: () => import('/builds/nangman/nangman-web/src/pages/mobile/analysis-saju-reading/_summary_sub_05.vue'),
            /* no children */
          },
          {
            path: '_summary_sub_06',
            name: 'mobile-analysis-saju-reading-summary-sub06',
            component: () => import('/builds/nangman/nangman-web/src/pages/mobile/analysis-saju-reading/_summary_sub_06.vue'),
            /* no children */
          },
          {
            path: '_summary_sub_07',
            name: 'mobile-analysis-saju-reading-summary-sub07',
            component: () => import('/builds/nangman/nangman-web/src/pages/mobile/analysis-saju-reading/_summary_sub_07.vue'),
            /* no children */
          },
          {
            path: '_summary_sub_09',
            name: 'mobile-analysis-saju-reading-summary-sub09',
            component: () => import('/builds/nangman/nangman-web/src/pages/mobile/analysis-saju-reading/_summary_sub_09.vue'),
            /* no children */
          },
          {
            path: '_summary_sub_10',
            name: 'mobile-analysis-saju-reading-summary-sub10',
            component: () => import('/builds/nangman/nangman-web/src/pages/mobile/analysis-saju-reading/_summary_sub_10.vue'),
            /* no children */
          },
          {
            path: '_summary_sub_11',
            name: 'mobile-analysis-saju-reading-summary-sub11',
            component: () => import('/builds/nangman/nangman-web/src/pages/mobile/analysis-saju-reading/_summary_sub_11.vue'),
            /* no children */
          },
          {
            path: '_summary_sub_12',
            name: 'mobile-analysis-saju-reading-summary-sub12',
            component: () => import('/builds/nangman/nangman-web/src/pages/mobile/analysis-saju-reading/_summary_sub_12.vue'),
            /* no children */
          },
          {
            path: '_summary_sub_13',
            name: 'mobile-analysis-saju-reading-summary-sub13',
            component: () => import('/builds/nangman/nangman-web/src/pages/mobile/analysis-saju-reading/_summary_sub_13.vue'),
            /* no children */
          },
          {
            path: '_summary_sub_14',
            name: 'mobile-analysis-saju-reading-summary-sub14',
            component: () => import('/builds/nangman/nangman-web/src/pages/mobile/analysis-saju-reading/_summary_sub_14.vue'),
            /* no children */
          },
          {
            path: '_summary_sub_15',
            name: 'mobile-analysis-saju-reading-summary-sub15',
            component: () => import('/builds/nangman/nangman-web/src/pages/mobile/analysis-saju-reading/_summary_sub_15.vue'),
            /* no children */
          },
          {
            path: '_summary_sub_16',
            name: 'mobile-analysis-saju-reading-summary-sub16',
            component: () => import('/builds/nangman/nangman-web/src/pages/mobile/analysis-saju-reading/_summary_sub_16.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'analysis-saju-yearly-fortune',
        /* internal name: 'mobile-analysis-saju-yearly-fortune' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'mobile-analysis-saju-yearly-fortune',
            component: () => import('/builds/nangman/nangman-web/src/pages/mobile/analysis-saju-yearly-fortune/index.vue'),
            /* no children */
          },
  _definePage_default_32
  ),
          {
            path: '_com_payment_info',
            name: 'mobile-analysis-saju-yearly-fortune-com-payment-info',
            component: () => import('/builds/nangman/nangman-web/src/pages/mobile/analysis-saju-yearly-fortune/_com_payment_info.vue'),
            /* no children */
          },
          {
            path: '_pop_desc',
            name: 'mobile-analysis-saju-yearly-fortune-pop-desc',
            component: () => import('/builds/nangman/nangman-web/src/pages/mobile/analysis-saju-yearly-fortune/_pop_desc.vue'),
            /* no children */
          },
          {
            path: '_summary_01',
            name: 'mobile-analysis-saju-yearly-fortune-summary01',
            component: () => import('/builds/nangman/nangman-web/src/pages/mobile/analysis-saju-yearly-fortune/_summary_01.vue'),
            /* no children */
          },
          {
            path: '_summary_02',
            name: 'mobile-analysis-saju-yearly-fortune-summary02',
            component: () => import('/builds/nangman/nangman-web/src/pages/mobile/analysis-saju-yearly-fortune/_summary_02.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'analysis-saju-youngsin',
        /* internal name: 'mobile-analysis-saju-youngsin' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'mobile-analysis-saju-youngsin',
            component: () => import('/builds/nangman/nangman-web/src/pages/mobile/analysis-saju-youngsin/index.vue'),
            /* no children */
          },
  _definePage_default_33
  ),
          {
            path: '_com_payment_info',
            name: 'mobile-analysis-saju-youngsin-com-payment-info',
            component: () => import('/builds/nangman/nangman-web/src/pages/mobile/analysis-saju-youngsin/_com_payment_info.vue'),
            /* no children */
          },
          {
            path: '_pop_desc',
            name: 'mobile-analysis-saju-youngsin-pop-desc',
            component: () => import('/builds/nangman/nangman-web/src/pages/mobile/analysis-saju-youngsin/_pop_desc.vue'),
            /* no children */
          },
          {
            path: '_summary_01',
            name: 'mobile-analysis-saju-youngsin-summary01',
            component: () => import('/builds/nangman/nangman-web/src/pages/mobile/analysis-saju-youngsin/_summary_01.vue'),
            /* no children */
          },
          {
            path: '_summary_02',
            name: 'mobile-analysis-saju-youngsin-summary02',
            component: () => import('/builds/nangman/nangman-web/src/pages/mobile/analysis-saju-youngsin/_summary_02.vue'),
            /* no children */
          },
          {
            path: '_summary_sub_01',
            name: 'mobile-analysis-saju-youngsin-summary-sub01',
            component: () => import('/builds/nangman/nangman-web/src/pages/mobile/analysis-saju-youngsin/_summary_sub_01.vue'),
            /* no children */
          },
          {
            path: '_summary_sub_02',
            name: 'mobile-analysis-saju-youngsin-summary-sub02',
            component: () => import('/builds/nangman/nangman-web/src/pages/mobile/analysis-saju-youngsin/_summary_sub_02.vue'),
            /* no children */
          },
          {
            path: '_summary_sub_03',
            name: 'mobile-analysis-saju-youngsin-summary-sub03',
            component: () => import('/builds/nangman/nangman-web/src/pages/mobile/analysis-saju-youngsin/_summary_sub_03.vue'),
            /* no children */
          },
          {
            path: '_summary_sub_04',
            name: 'mobile-analysis-saju-youngsin-summary-sub04',
            component: () => import('/builds/nangman/nangman-web/src/pages/mobile/analysis-saju-youngsin/_summary_sub_04.vue'),
            /* no children */
          },
          {
            path: '_summary_sub_05',
            name: 'mobile-analysis-saju-youngsin-summary-sub05',
            component: () => import('/builds/nangman/nangman-web/src/pages/mobile/analysis-saju-youngsin/_summary_sub_05.vue'),
            /* no children */
          },
          {
            path: '_summary_sub_06',
            name: 'mobile-analysis-saju-youngsin-summary-sub06',
            component: () => import('/builds/nangman/nangman-web/src/pages/mobile/analysis-saju-youngsin/_summary_sub_06.vue'),
            /* no children */
          },
          {
            path: '_summary_sub_07',
            name: 'mobile-analysis-saju-youngsin-summary-sub07',
            component: () => import('/builds/nangman/nangman-web/src/pages/mobile/analysis-saju-youngsin/_summary_sub_07.vue'),
            /* no children */
          },
          {
            path: '_summary_sub_08',
            name: 'mobile-analysis-saju-youngsin-summary-sub08',
            component: () => import('/builds/nangman/nangman-web/src/pages/mobile/analysis-saju-youngsin/_summary_sub_08.vue'),
            /* no children */
          },
          {
            path: '_summary_sub_09',
            name: 'mobile-analysis-saju-youngsin-summary-sub09',
            component: () => import('/builds/nangman/nangman-web/src/pages/mobile/analysis-saju-youngsin/_summary_sub_09.vue'),
            /* no children */
          },
          {
            path: '_summary_sub_10',
            name: 'mobile-analysis-saju-youngsin-summary-sub10',
            component: () => import('/builds/nangman/nangman-web/src/pages/mobile/analysis-saju-youngsin/_summary_sub_10.vue'),
            /* no children */
          },
          {
            path: '_summary_sub_11',
            name: 'mobile-analysis-saju-youngsin-summary-sub11',
            component: () => import('/builds/nangman/nangman-web/src/pages/mobile/analysis-saju-youngsin/_summary_sub_11.vue'),
            /* no children */
          },
          {
            path: '_summary_sub_12',
            name: 'mobile-analysis-saju-youngsin-summary-sub12',
            component: () => import('/builds/nangman/nangman-web/src/pages/mobile/analysis-saju-youngsin/_summary_sub_12.vue'),
            /* no children */
          },
          {
            path: '_summary_sub_13',
            name: 'mobile-analysis-saju-youngsin-summary-sub13',
            component: () => import('/builds/nangman/nangman-web/src/pages/mobile/analysis-saju-youngsin/_summary_sub_13.vue'),
            /* no children */
          },
          {
            path: '_summary_sub_14',
            name: 'mobile-analysis-saju-youngsin-summary-sub14',
            component: () => import('/builds/nangman/nangman-web/src/pages/mobile/analysis-saju-youngsin/_summary_sub_14.vue'),
            /* no children */
          },
          {
            path: '_summary_sub_15',
            name: 'mobile-analysis-saju-youngsin-summary-sub15',
            component: () => import('/builds/nangman/nangman-web/src/pages/mobile/analysis-saju-youngsin/_summary_sub_15.vue'),
            /* no children */
          },
          {
            path: '_summary_sub_16',
            name: 'mobile-analysis-saju-youngsin-summary-sub16',
            component: () => import('/builds/nangman/nangman-web/src/pages/mobile/analysis-saju-youngsin/_summary_sub_16.vue'),
            /* no children */
          },
          {
            path: '_summary_sub_17',
            name: 'mobile-analysis-saju-youngsin-summary-sub17',
            component: () => import('/builds/nangman/nangman-web/src/pages/mobile/analysis-saju-youngsin/_summary_sub_17.vue'),
            /* no children */
          },
          {
            path: '_summary_sub_18',
            name: 'mobile-analysis-saju-youngsin-summary-sub18',
            component: () => import('/builds/nangman/nangman-web/src/pages/mobile/analysis-saju-youngsin/_summary_sub_18.vue'),
            /* no children */
          },
          {
            path: '_summary_sub_19',
            name: 'mobile-analysis-saju-youngsin-summary-sub19',
            component: () => import('/builds/nangman/nangman-web/src/pages/mobile/analysis-saju-youngsin/_summary_sub_19.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'five-element-diagram',
        /* internal name: 'mobile-five-element-diagram' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'mobile-five-element-diagram',
            component: () => import('/builds/nangman/nangman-web/src/pages/mobile/five-element-diagram/index.vue'),
            /* no children */
          },
  _definePage_default_34
  )
        ],
      },
      {
        path: 'saju-analysis',
        /* internal name: 'mobile-saju-analysis' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'mobile-saju-analysis',
            component: () => import('/builds/nangman/nangman-web/src/pages/mobile/saju-analysis/index.vue'),
            /* no children */
          },
  _definePage_default_35
  )
        ],
      },
      {
        path: 'saju-disposition',
        /* internal name: 'mobile-saju-disposition' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'mobile-saju-disposition',
            component: () => import('/builds/nangman/nangman-web/src/pages/mobile/saju-disposition/index.vue'),
            /* no children */
          },
  _definePage_default_36
  ),
          {
            path: '_summary_sub_01',
            name: 'mobile-saju-disposition-summary-sub01',
            component: () => import('/builds/nangman/nangman-web/src/pages/mobile/saju-disposition/_summary_sub_01.vue'),
            /* no children */
          },
          {
            path: '_summary_sub_02',
            name: 'mobile-saju-disposition-summary-sub02',
            component: () => import('/builds/nangman/nangman-web/src/pages/mobile/saju-disposition/_summary_sub_02.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'saju-iljin',
        /* internal name: 'mobile-saju-iljin' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'mobile-saju-iljin',
            component: () => import('/builds/nangman/nangman-web/src/pages/mobile/saju-iljin/index.vue'),
            /* no children */
          },
  _definePage_default_37
  )
        ],
      },
      {
        path: 'saju-reading',
        /* internal name: 'mobile-saju-reading' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'mobile-saju-reading',
            component: () => import('/builds/nangman/nangman-web/src/pages/mobile/saju-reading/index.vue'),
            /* no children */
          },
  _definePage_default_38
  )
        ],
      }
    ],
  },
  {
    path: '/mypage',
    /* internal name: 'mypage' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: 'history',
        name: 'mypage-history',
        component: () => import('/builds/nangman/nangman-web/src/pages/mypage/history.vue'),
        /* no children */
      },
  _definePage_default_39
  ),
  _mergeRouteRecord(
      {
        path: 'inquiry',
        name: 'mypage-inquiry',
        component: () => import('/builds/nangman/nangman-web/src/pages/mypage/inquiry.vue'),
        /* no children */
      },
  _definePage_default_40
  ),
  _mergeRouteRecord(
      {
        path: 'inquiryFinish',
        name: 'mypage-inquiry-finish',
        component: () => import('/builds/nangman/nangman-web/src/pages/mypage/inquiryFinish.vue'),
        /* no children */
      },
  _definePage_default_41
  ),
  _mergeRouteRecord(
      {
        path: 'inquiryGuest',
        name: 'mypage-inquiry-guest',
        component: () => import('/builds/nangman/nangman-web/src/pages/mypage/inquiryGuest.vue'),
        /* no children */
      },
  _definePage_default_42
  ),
  _mergeRouteRecord(
      {
        path: 'inquiryList',
        name: 'mypage-inquiry-list',
        component: () => import('/builds/nangman/nangman-web/src/pages/mypage/inquiryList.vue'),
        /* no children */
      },
  _definePage_default_43
  ),
  _mergeRouteRecord(
      {
        path: 'inquiryView',
        name: 'mypage-inquiry-view',
        component: () => import('/builds/nangman/nangman-web/src/pages/mypage/inquiryView.vue'),
        /* no children */
      },
  _definePage_default_44
  ),
  _mergeRouteRecord(
      {
        path: 'moreinfo',
        name: 'mypage-moreinfo',
        component: () => import('/builds/nangman/nangman-web/src/pages/mypage/moreinfo.vue'),
        /* no children */
      },
  _definePage_default_45
  ),
  _mergeRouteRecord(
      {
        path: 'myinfo',
        name: 'mypage-myinfo',
        component: () => import('/builds/nangman/nangman-web/src/pages/mypage/myinfo.vue'),
        /* no children */
      },
  _definePage_default_46
  ),
  _mergeRouteRecord(
      {
        path: 'snsPw',
        name: 'mypage-sns-pw',
        component: () => import('/builds/nangman/nangman-web/src/pages/mypage/snsPw.vue'),
        /* no children */
      },
  _definePage_default_47
  ),
  _mergeRouteRecord(
      {
        path: 'subscription',
        name: 'mypage-subscription',
        component: () => import('/builds/nangman/nangman-web/src/pages/mypage/subscription.vue'),
        /* no children */
      },
  _definePage_default_48
  ),
  _mergeRouteRecord(
      {
        path: 'subscrPaymentView',
        name: 'mypage-subscr-payment-view',
        component: () => import('/builds/nangman/nangman-web/src/pages/mypage/subscrPaymentView.vue'),
        /* no children */
      },
  _definePage_default_49
  ),
  _mergeRouteRecord(
      {
        path: 'withdraw-finish',
        name: 'mypage-withdraw-finish',
        component: () => import('/builds/nangman/nangman-web/src/pages/mypage/withdraw-finish.vue'),
        /* no children */
      },
  _definePage_default_50
  )
    ],
  },
  {
    path: '/nangman-center',
    /* internal name: 'nangman-center' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: 'nangman-center',
        component: () => import('/builds/nangman/nangman-web/src/pages/nangman-center/index.vue'),
        /* no children */
      },
  _definePage_default_51
  ),
      {
        path: 'essay',
        /* internal name: 'nangman-center-essay' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: ':essayId',
            name: 'nangman-center-essay-essay-id',
            component: () => import('/builds/nangman/nangman-web/src/pages/nangman-center/essay/[essayId].vue'),
            /* no children */
          },
  _definePage_default_52
  )
        ],
      }
    ],
  },
  {
    path: '/onboarding',
    /* internal name: 'onboarding' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: 'onboarding',
        component: () => import('/builds/nangman/nangman-web/src/pages/onboarding/index.vue'),
        /* no children */
      },
  _definePage_default_53
  )
    ],
  },
  {
    path: '/partner',
    /* internal name: 'partner' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: 'smartwel',
        name: 'partner-smartwel',
        component: () => import('/builds/nangman/nangman-web/src/pages/partner/smartwel.vue'),
        /* no children */
      },
  _definePage_default_54
  )
    ],
  },
  {
    path: '/purchase',
    /* internal name: 'purchase' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: 'exchange',
        name: 'purchase-exchange',
        component: () => import('/builds/nangman/nangman-web/src/pages/purchase/exchange.vue'),
        /* no children */
      },
  _definePage_default_55
  ),
  _mergeRouteRecord(
      {
        path: 'gift-box',
        name: 'purchase-gift-box',
        component: () => import('/builds/nangman/nangman-web/src/pages/purchase/gift-box.vue'),
        /* no children */
      },
  _definePage_default_56
  ),
  _mergeRouteRecord(
      {
        path: 'gift-claim',
        name: 'purchase-gift-claim',
        component: () => import('/builds/nangman/nangman-web/src/pages/purchase/gift-claim.vue'),
        /* no children */
      },
  _definePage_default_57
  ),
  _mergeRouteRecord(
      {
        path: 'gift-view',
        name: 'purchase-gift-view',
        component: () => import('/builds/nangman/nangman-web/src/pages/purchase/gift-view.vue'),
        /* no children */
      },
  _definePage_default_58
  ),
  _mergeRouteRecord(
      {
        path: 'nmspFinishPoint',
        name: 'purchase-nmsp-finish-point',
        component: () => import('/builds/nangman/nangman-web/src/pages/purchase/nmspFinishPoint.vue'),
        /* no children */
      },
  _definePage_default_59
  ),
  _mergeRouteRecord(
      {
        path: 'nmspFinishPointEnd',
        name: 'purchase-nmsp-finish-point-end',
        component: () => import('/builds/nangman/nangman-web/src/pages/purchase/nmspFinishPointEnd.vue'),
        /* no children */
      },
  _definePage_default_60
  ),
  _mergeRouteRecord(
      {
        path: 'nmspFinishPointFail',
        name: 'purchase-nmsp-finish-point-fail',
        component: () => import('/builds/nangman/nangman-web/src/pages/purchase/nmspFinishPointFail.vue'),
        /* no children */
      },
  _definePage_default_61
  ),
  _mergeRouteRecord(
      {
        path: 'points',
        name: 'purchase-points',
        component: () => import('/builds/nangman/nangman-web/src/pages/purchase/points.vue'),
        /* no children */
      },
  _definePage_default_62
  ),
  _mergeRouteRecord(
      {
        path: 'ticket-detail',
        name: 'purchase-ticket-detail',
        component: () => import('/builds/nangman/nangman-web/src/pages/purchase/ticket-detail.vue'),
        /* no children */
      },
  _definePage_default_63
  ),
  _mergeRouteRecord(
      {
        path: 'tickets',
        name: 'purchase-tickets',
        component: () => import('/builds/nangman/nangman-web/src/pages/purchase/tickets.vue'),
        /* no children */
      },
  _definePage_default_64
  )
    ],
  },
  {
    path: '/saju-input',
    /* internal name: 'saju-input' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: 'saju-input',
        component: () => import('/builds/nangman/nangman-web/src/pages/saju-input/index.vue'),
        /* no children */
      },
  _definePage_default_65
  )
    ],
  },
  {
    path: '/saju-insight',
    /* internal name: 'saju-insight' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: 'saju-insight',
        component: () => import('/builds/nangman/nangman-web/src/pages/saju-insight/index.vue'),
        /* no children */
      },
  _definePage_default_66
  )
    ],
  },
  {
    path: '/saju-naming',
    /* internal name: 'saju-naming' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: 'saju-naming',
        component: () => import('/builds/nangman/nangman-web/src/pages/saju-naming/index.vue'),
        /* no children */
      },
  _definePage_default_67
  )
    ],
  },
  {
    path: '/saju-print',
    /* internal name: 'saju-print' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: 'print-nor',
        name: 'saju-print-print-nor',
        component: () => import('/builds/nangman/nangman-web/src/pages/saju-print/print-nor.vue'),
        /* no children */
      },
  _definePage_default_68
  ),
  _mergeRouteRecord(
      {
        path: 'print-pro',
        name: 'saju-print-print-pro',
        component: () => import('/builds/nangman/nangman-web/src/pages/saju-print/print-pro.vue'),
        /* no children */
      },
  _definePage_default_69
  )
    ],
  },
  {
    path: '/saju-result',
    /* internal name: 'saju-result' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: 'saju-result',
        component: () => import('/builds/nangman/nangman-web/src/pages/saju-result/index.vue'),
        /* no children */
      },
  _definePage_default_70
  )
    ],
  },
  {
    path: '/saju-service',
    /* internal name: 'saju-service' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: 'saju-service',
        component: () => import('/builds/nangman/nangman-web/src/pages/saju-service/index.vue'),
        /* no children */
      },
  _definePage_default_71
  )
    ],
  },
  {
    path: '/selection',
    /* internal name: 'selection' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: 'selection',
        component: () => import('/builds/nangman/nangman-web/src/pages/selection/index.vue'),
        /* no children */
      },
  _definePage_default_72
  )
    ],
  }
]
